<div class="row">
  <div class="col-sm-12">
    <div class="card card-border">
      <div class="card-header  mb-2">
        <div class="form-group row mb-2">
          <div class="texto-justificado">
            <span><b>RIESGO DEL PLAN DE ACCIÓN: </b>{{nameRiesgo}}</span>
          </div>
        </div>
      </div>

      <!-- TABLA -->
      <div class="container card-body table-responsive">
        <div class="row mb-2" *hasDenied="{nivel:idSprNivel, app: constant.RIESGOS}" >
          <div class="col-sm-6 text-sm-right">
            <button *hasPermission="{app: constant.RIESGOS, permission: [constant.CREAR]}" type="button" class="btn btn-sm btn-success waves-effect" (click)="openModalAccion()">
              <i class="fas fa-plus fa-lg mr-1"></i> Nuevo</button>
          </div>
        </div>

        <table 
          class="table table-striped table-bordered row-border hover">
          <thead>
            <tr>
              <th>Nro.</th>
              <th>Acciones</th>
              <th>Fecha comprometida</th>
              <th>Peso</th>
              <th>Cumplimiento</th>
              <th>Semáforo</th>
              <th>Fecha de cumplimiento</th>
              <th class="text-center">Documento de soporte</th>
              <th>Estado</th>
              <th>Seguimiento</th>
              <th>Acción</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let accion of dataAccion; let indice=index">
              <td>{{indice+1}} </td>
              <td>
                <p class="text-justify">{{ ((accion.descripcion.length < 70)? accion.descripcion:
                    accion.descripcion.substring(0,67) + '. . .' )}}</p>
              </td>
              <td>{{accion.fechaComprometida}}</td>

              <td>{{accion.peso}} %</td>
              <td *ngIf="accion.cumplimiento == 1">
                <p class="text-success text-center col-sm-auto">SI</p>
              </td>
              <td *ngIf="accion.cumplimiento == 1">
                <p class="text-center col-sm-auto">
                  <i class="fa fa-circle m-r-20 fa-lg" style="color: green"></i>
                </p>
              </td>
              <td *ngIf="accion.cumplimiento == 2">
                <p class="text-danger text-center col-sm-auto">NO</p>
              </td>
              <td *ngIf="accion.cumplimiento == 2">
                <p class="text-center col-sm-auto">
                  <i class="fa fa-circle m-r-10 fa-lg" style="color: red"></i>
                </p>
              </td>
              <td *ngIf="accion.cumplimiento == 0">
                <p class="text-danger text-center col-sm-auto">NO</p>
              </td>
              <td *ngIf="accion.cumplimiento == 0">
                <p class="text-center col-sm-auto">
                  <i class="fa fa-circle m-r-10 fa-lg" style="color: red"></i>
                </p>
              </td>
              <td>
                <div *ngIf="accion.respaldo != null">
                  {{ (accion.fecha | date : 'dd-MM-yyyy')}}
                </div>
              </td>
              <td  class="plan-column" style="max-width: 300px; word-wrap: break-word; white-space: normal;">
                <div *ngIf="accion.respaldo != null">
                  <div class="row">
                    <button type="button" tooltip="Visualizar pdf respaldo" class="btn btn-sm btn-link waves-effect rounded-pill" title="Documento de soporte" (click)="visualizarPdf(accion.respaldo)">
                      <i class="fas fa-file-pdf  fa-lg"></i>
                      <div class="text-center">
                      <span (click)="visualizarPdf(accion.respaldo)">{{accion.respaldo}}</span>
                    </div>
                    </button>
                  </div>
                </div>
              </td>
              <td>{{((accion.estado == '1')? 'Activo': 'Inactivo')}}</td>

              <td class="text-center col-sm-auto">
                <button type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill" title="Evaluación de la acción" (click)="evaluacionAccion(accion)">
                  <i class="fas fa-check-double fa-lg"></i>
                </button>
              </td>

              <td class="text-center col-sm-auto">
                <div class="row" *hasDenied="{nivel:idSprNivel, app: constant.RIESGOS}">
                <button *hasPermission="{app: constant.RIESGOS, permission: [constant.ACTUALIZAR]}" type="button" tooltip="Editar" class="btn btn-sm btn-link waves-effect rounded-pill" title="Editar este registro" (click)="editar(accion)">
                  <i class="fas fa-pencil-alt fa-lg"></i>
                </button>
                <button *hasPermission="{app: constant.RIESGOS, permission: [constant.BORRAR]}" type="button" class="btn btn-sm btn-link waves-effect" title="Eliminar este registro" (click)="delete(accion.idSprAccion)">
                  <i class="fas fa-trash-alt fa-lg"></i>
                </button>
              </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- TABLA FIN -->
  </div>
</div>

<!-- MENSAJE DE ELIMINAR -->
<jw-modal id="deleteAccionPlan" [isDelete]="true" (confirmation)="confirmDelete()"></jw-modal>
<!-- MENSAJE DE ELIMINAR FIN -->

<!-- MODAL PARA CREAR Y EDITAR -->
<jw-modal id="{{modalAccionPlan}}" class="index">
  <div class="modal-dialog modal-lg modal-dialog-scrollable" style="padding-top:6%" role="document">
    <div class="modal-content">
      <div class="modal-header pb-3">
        <h3 class="modal-title">{{nameAppAccion}}</h3>
        <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
      </div>

      <div class="card-body pT-4">
        <form class="needs-validation " id="formPlanAccion" id="formAccion" [formGroup]="formAccion" autocomplete="off">
          <div>
            <div class="form-group row mb-2">
              <div class="col col-md-2 text-md-right">
                <label for="descripcion" class=" form-control-label text-md-right pt-1"><b>Acción:</b></label>
              </div>
              <div class="col-12 col-md-10">
                <textarea type="text" class="form-control" required="true" formControlName="descripcion" id="descripcion" (keyup)="onKey($event)" [ngClass]="{ 'is-invalid': this.formAccion.get('descripcion')?.errors && this.submitted,'is-valid': !this.formAccion.get('descripcion')?.errors, }">
                </textarea>
                <div id="contador"></div>

                <small class="invalid-feedback" *ngIf="this.formAccion.get('descripcion')?.errors?.['required'] && this.submitted">Campo requerido</small>
              </div>
            </div>

            <div class="form-group row mb-2">
              <div class="col col-md-2 text-md-right">
                <label for="fechaComprometida" class=" form-control-label text-md-right pt-1"><b>Fecha comprometida:</b></label>
              </div>
              <div class="col-12 col-md-4">
                <input type="date" class="form-control" required="true" placeholder="fechaComprometida" formControlName="fechaComprometida" [ngClass]="{'is-invalid': this.formAccion.get('fechaComprometida')?.errors && this.submitted,'is-valid': !this.formAccion.get('fechaComprometida')?.errors,}" date [readonly]="desahabilitarForm">
                <small class="invalid-feedback" *ngIf="this.formAccion.get('fechaComprometida')?.errors?.['required'] && this.submitted">Campo requerido</small>
                <div class="col text-danger">
                  <span class="font-italic" *ngIf="this.formAccion.get('fechaComprometida').errors?.fechaInicio">La fecha debe estar comprendida entre {{this.formAccion.get('fechaComprometida')?.errors.fechaInicio}} y {{this.formAccion.get('fechaComprometida')?.errors.fechaFin}}
                  </span>
                </div>
              </div>

              <div class="col col-md-2 text-md-right">
                <label for="idSprTipoAccion" class="col-form-label text-md-right"><b>Tipo acción:</b></label>
              </div>
              <div class="col-12 col-md-4">
                <select class="form-select" id="idSprTipoAccion" formControlName="idSprTipoAccion" required="true" [ngClass]="{'is-invalid': this.formAccion.get('idSprTipoAccion')?.errors && this.submitted,'is-valid': !this.formAccion.get('idSprTipoAccion')?.errors,}">
                  <option value="" selected="selected">Seleccionar..</option>
                  <option *ngFor="let catRiesgoEdr of dataCatComun" value="{{ catRiesgoEdr.idSprComun }}">
                    {{ catRiesgoEdr.nombre }}
                  </option>
                </select>
                <div class="col text-danger">
                  <small class="font-italic" *ngIf="this.formAccion.get('idSprTipoAccion')?.errors?.['required'] && this.submitted">Campo requerido</small>
                </div>
              </div>
            </div>

            <div class="form-group row mb-2">
              <div class="col col-md-2 text-md-right">
                <label for="peso" class=" form-control-label text-md-right pt-1"><b>Peso actividad (%):</b></label>
              </div>
              <div class="col-12 col-md-4">
                <input type="number" min="0" max="100" maxlength="3" onkeydown="return false" name="peso" id="peso" placeholder="Solo caracteres Numericos" class="form-control" required autocomplete="off" onkeypress="return(event.charCode>= 48 && event.charCode <= 57)" formControlName="peso" required
                  autofocus placeholder="peso" [ngClass]="{'is-invalid': this.formAccion.get('peso')?.errors && this.submitted,'is-valid': !this.formAccion.get('peso')?.errors,}">
                <small class="invalid-feedback" *ngIf="this.formAccion.get('peso')?.errors?.['required'] && this.submitted">Campo requerido</small>
              </div>

              <div *ngIf="editPorcentajeTotal" class="col col-md-2 text-md-right">
                <label for="calificacion" class="form-control-label text-md-right pt-1"><b>Porcentaje restante (%):</b>
                </label>
              </div>
              <div *ngIf="editPorcentajeTotal" class="col-12 col-md-4">
                <input class="form-control" disabled style="background-color: #e9e8e8;"
                  placeholder="{{pesoRestante}} %" />
              </div>

              <div *ngIf="editPorcentaje" class="col col-md-2 text-md-right">
                <label for="calificacion" class="form-control-label text-md-right pt-1"><b>Porcentaje restante (%):</b>
                </label>
              </div>
              <div *ngIf="editPorcentaje" class="col-12 col-md-4">
                <input class="form-control" disabled style="background-color: #f5f4f4;"
                  placeholder="{{pesoTotalEditado}} %" />
              </div>
            </div>

            <div class="form-group row mb-2">
              <div class="col col-md-2 text-xl-right">
                <label for="estado" class=" form-control-label text-md-right pt-1"><b>Estado:</b></label>
              </div>
              <div class="col-12 col-md-4">
                <select id="estado" class="form-select" formControlName="estado" required [ngClass]="{'is-invalid': this.formAccion.get('estado')?.errors && this.submitted,'is-valid': !this.formAccion.get('estado')?.errors,}" [disabled]="desahabilitarForm">
                  <option [value]="item.value" *ngFor="let item of selectItems">
                    {{item.label}}
                  </option>
                </select>
                <small class="invalid-feedback" *ngIf="this.formAccion.get('estado')?.errors?.['required'] && this.submitted">Campo requerido</small>
              </div>
            </div>
          </div>

          <div class="modal-footer" id="modal">
            <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal"
              (click)="closeModal()">Cerrar
            </button>
            <button type="button" class="btn btn-info" (click)="onSubmit()">
              Guardar
            </button>
          </div>
        </form>
      </div>

    </div>
  </div>
</jw-modal>


<jw-modal id="{{modalCumpleAccionPlan}}">
  <div class="modal-dialog modal-lg " style="margin-top: 120px;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">{{nameAppAccion}}</h3>
        <button type="button" class="btn-close" (click)="closeModalCumplimientoIndicadorAdmin(modalCumpleAccionPlan)"
          aria-label="Close"></button>
      </div>
      <div class="card mb-1">
        <div class="card-body px-5">
          <form class="needs-validation was-validated" novalidate id="formPlanAccion" id="formAccionCumple"
            [formGroup]="formAccionCumple" autocomplete="off">
            <div class="container card-body mb-2 table-responsive "
              style="background-color: #f2f3f4; border-radius:20px; border:1px solid  #d3d4d6;box-shadow: 2px 2px 5px #999 ">

              <div class="form-group row mb-2">
                <div class="col col-md-3">
                  <b><span style="text-align:right; display:block">Acción:</span></b>
                </div>
                <div class="col col-md-8">
                  <span>{{descripcion}}</span>
                </div>
              </div>

              <div class="form-group row mb-2">
                <div class="col col-md-3">
                  <b><span style="text-align:right; display:block">Peso actividad:</span></b>
                </div>
                <div class="col col-md-3">
                  <span>{{peso}} %</span>
                </div>
                <div class="col col-md-3 ">
                  <b><span style="text-align:right; display:block">Tipo Acción:</span></b>
                </div>
                <div class="col col-md-3">
                  <span>{{tipoAccion}}</span>
                </div>
              </div>

              <div class="form-group row mb-2">
                <div class="col col-md-3">
                  <b><span style="text-align:right; display:block">Fecha comprometida:</span></b>
                </div>
                <div class="col col-md-3">
                  <span>{{fechaComprometida  | date: 'dd-MM-yyyy'}}</span>
                </div>
              </div>
            </div>

            <div class="shadow-sm p-2 card-header mb-2 rounded py-1">
              <span><h1 style="font-size: larger; font-weight: normal; margin-bottom: 0;">CUMPLIMIENTO</h1></span>
          </div> 
            <div class="form-group row mb-2">
              <div class="col col-md-2 text-md-right">
                <label for="respaldo" class=" form-control-label text-md-right pt-1"><b>Documento de soporte:</b></label>
              </div>
              <div class="col-12 col-md-10">
                <input #myInput type="file" class="form-control" id="respaldo" formControlName="respaldo" (change)="capturarFile($event)" required="true" [ngClass]="{'is-invalid': this.formAccionCumple.get('respaldo')?.errors && this.submitted,'is-valid': !this.formAccionCumple.get('respaldo')?.errors,}">
                <small class="invalid-feedback" *ngIf="this.formAccionCumple.get('respaldo')?.errors?.['required'] && this.submitted">Campo requerido</small>
              </div>
            </div>
            <div class="form-group row mb-2">

            </div>
            <div class="modal-footer" id="modal">
              <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal"
                (click)="closeModalCumplimientoIndicadorAdmin(modalCumpleAccionPlan)">Cerrar
              </button>
              <button type="button" class="btn btn-info" (click)="subirArchivo()">
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</jw-modal>